import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EstimateProfitUtil } from '@/class/cargo/model/utils/EstimateProfitUtil'
import { CreditControlUtil } from '@/class/cargo/model/utils/CreditControlUtil'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import ErrorTip from '@/utils/class/ErrorTip'
import { deepCopy } from '@/utils/commonUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export class DocumentWorkspacePM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.chargeAccountIdObject = null
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get currentRow() {
    return this.view.currentRow
  }
  set currentRow(currentRow) {
    this.view.currentRow = currentRow
  }
  get paramsOfTab() {
    return this.view.paramsOfTab
  }
  set paramsOfTab(paramsOfTab) {
    this.view.paramsOfTab = paramsOfTab
  }
  /**
   * 在保存前进行校验
   */
  async checkBeforeSave() {
    const job = this.paramsOfTab
    // 中邮委托单位是否黑名单
    const blacklist = await JobUtils.checkBlacklistByCustomerId(job.customerId, !(job.uuid && job.customerId === this.currentRow.customerId))
    if (blacklist) {
      if (!job.uuid || (job.uuid && job.customerId !== this.currentRow.customerId)) {
        return false
      }
    }
    const reqInputCharge = Number(this.config.get('saveCharge')) === 1
    const isBookingFeeMandatoryAppliedGlobally = Number(this.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
    let checkEstimate = Boolean(job.uuid)
    if (!(job.lclMasterUuid && !job.uuid) && !SecurityUtil.checkSaveCharge(reqInputCharge, job, isBookingFeeMandatoryAppliedGlobally)) {
      return
    }
    // 判断主票新增小票后，编辑小票，判断费用是否都是新创建的，如果是，对小票进行预估计算以及利润率验证
    let isNewCharge = false
    let index = 0
    if (job.lclMasterUuid && job.charges && job.charges.length > 0 && job.uuid) {
      for (const c of job.charges) {
        if (!c.uuid) {
          ++index
        }
      }
      if (job.charges.length === index) {
        isNewCharge = true
      }
    }
    // 不更新賬單信息
    job.skipBillsForNextTransaction = true
    // 有些数据无需保存
    if (job.charges) {
      for (const c2 of job.charges) {
        c2.skipClearHistoryForNextTransaction = true
        c2.skipHedgeChargeForNextTransaction = true
      }
    }
    if (((!job.lclMasterUuid && !job.uuid) || isNewCharge) && reqInputCharge && !checkEstimate && !isBookingFeeMandatoryAppliedGlobally) {
      checkEstimate = await EstimateProfitUtil.checkEstimate(job, params => {
        let resolveRef = null
        const result = new Promise(resolve => {
          resolveRef = resolve
        })
        const dialog = this.view.estimateValidationDialog
        dialog.job = params.job
        dialog.estimateProfitRate = params.estimateProfitRate
        dialog.tatolProfit = params.tatolProfit
        dialog.callback = isSave => {
          resolveRef(isSave)
        }
        dialog.visible = true
        this.view.$nextTick(() => {
          this.view.estimateValidationDialog.exgrossProfit()
        })
        return result
      })
      if (!checkEstimate) {
        return
      }
    }
    let flag = await CreditControlUtil.checkCreditBlack(job, !blacklist, this.currentRow)
    if (!flag) {
      return false
    }
    flag = await this.checkSalesChenged()
    if (!flag) {
      return false
    }
    flag = await this.checkOpSales()
    if (!flag) {
      return false
    }
    flag = await this.checkWarehouseRecord()
    if (!flag) {
      return false
    }
    flag = await this.checkChargeAccountId()
    if (!flag) {
      return false
    }
    flag = await this.checkCargoSource()
    if (!flag) {
      return false
    }
    const checkJobFields = {}
    const needConfirmeDuplicateWarehouseNo = Number(this.config.get('needConfirmeDuplicateWarehouseNo')) === 1
    if (needConfirmeDuplicateWarehouseNo && job.warehouseNo) {
      checkJobFields.warehouseNo = job.warehouseNo
    }
    if (job.soNo) {
      checkJobFields.soNo = job.soNo.replace(/\n/g, ',')
    }
    const fieldExistResult = await SeaExportJob.checkJobFieldExist(this.context.office.officeId, job.lob, checkJobFields, job.uuid)
    if (typeof fieldExistResult.warehouseNo !== 'undefined') {
      flag = await this.checkWarehouseNo(fieldExistResult.warehouseNo)
      if (!flag) {
        return false
      }
    }
    flag = await this.checkMBL()
    if (!flag) {
      return false
    }
    flag = await this.checkHBLExistHandler()
    if (!flag) {
      return false
    }
    if (typeof fieldExistResult.soNo !== 'undefined') {
      flag = await this.checkSoNo(fieldExistResult.soNo)
      if (!flag) {
        return false
      }
    }
    flag = await this.checkAmsContainersHandler()
    // if (!flag) {
    //   return false
    // }
    return flag
  }
  /**
   * 检查销售是否发生变更
   */
  async checkSalesChenged() {
    const job = this.paramsOfTab
    // 手动修改销售时，salesRecord为销售新值，联动修改销售时，此处将salesRecord改为旧值
    if (typeof job.salesRecord === 'undefined') {
      job.salesRecord = this.currentRow.sales
    }
    const norminationJobSaleType = Number(this.config.get('NorminationJobSaleType')) === 1
    if (job.uuid && job.salesRecord !== job.sales && (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code || norminationJobSaleType) && this.currentRow.sales !== job.sales) {
      return await this.$confirm(this.view.$t('Message.ChangeSelectSales'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 检查销售和操作是否相同
   */
  async checkOpSales() {
    const job = this.paramsOfTab
    if (job.sales !== 0 && job.sales === job.op) {
      return await this.$confirm(this.view.$t('Message.TheSameSalesAndOperationsConfirmThatYouWantToSave'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 检查仓库是否清除
   */
  async checkWarehouseRecord() {
    const job = this.paramsOfTab
    if (typeof job.warehouseRecord === 'undefined') {
      job.warehouseRecord = this.currentRow.warehouseCmp || 0
    }
    if (job.uuid && job.warehouseRecord !== job.warehouseCmp && !job.masterFlag && this.currentRow.warehouseCmp !== job.warehouseCmp) {
      return await this.$confirm(this.view.$t('Message.UpdateWarehouseRecord'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 验证费 输入
   */
  async checkChargeAccountId() {
    const job = this.paramsOfTab
    let messageTitle = ''
    let company = null
    if (job.charges && job.charges.length > 0) {
      for (const charge of job.charges) {
        if (charge.accountId > 0) {
          company = this.companyList.find(p => p.cmpIdx === charge.accountId)
          if (company && !company.active) {
            if (!this.chargeAccountIdObject || !this.chargeAccountIdObject[company.uuid]) {
              if (company.chineseName) {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.chineseName)
              } else {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.englishName)
              }
              break
            }
          }
        }
      }
    }
    if (messageTitle) {
      return await this.$confirm(messageTitle, this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.chargeAccountIdObject = this.chargeAccountIdObject || {}
        this.chargeAccountIdObject[company.uuid] = company.uuid
        return true
      }).catch(() => false)
    } else {
      return true
    }
  }
  /**
  * 检查揽货类型和小票
  */
  async checkCargoSource() {
    const job = this.paramsOfTab
    if (job.masterFlag) {
      let notSame = false
      for (const item of job.lclSlaves) {
        if (item.cargoSource !== job.cargoSource) {
          notSame = true
          break
        }
      }
      if (notSame) {
        return await this.$confirm(this.view.$t('Message.SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt'), this.view.$t('FileHistory.Tips'), {
          confirmButtonText: this.view.$t('constant.yes'),
          cancelButtonText: this.view.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => true).catch(() => false)
      }
    }
    return true
  }
  /**
   * 检测WarehouseNo是否重复
   */
  async checkWarehouseNo(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.WHNoRepeatedContinue'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  /**
   * 检查MBL是否可用
   */
  async checkMBL() {
    const job = this.paramsOfTab
    if (job.uuid && job.mbl && job.mbl.trim()) {
      const count = await SeaExportJob.isExistMBL(this.context.office.officeId, 'SE', job.mbl, job.uuid, job.etd)
      return await this.checkMBLResultHandler(count > 0)
    } else {
      return true
    }
  }
  async checkMBLResultHandler(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.MblNoRepeatedContinue'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  /**
   * 检查HBL是否可用
   */
  async checkHBLExistHandler() {
    const job = this.paramsOfTab
    const hbl = await new SeaExportJob(job).getMainHbl()
    for (const cd of job.seaCargoDoc) {
      if (cd.docType === 'HBL') {
        const s = job.containerDesc
        if (s && !cd.container) {
          cd.container = s.toLocaleUpperCase()
        }
      }
    }
    if (job.editCftMode && (hbl.shipperId === 0 || hbl.consigneeId === 0 || hbl.notifyId === 0)) {
      throw ErrorTip(this.view.$t('SeaExport.ConsigneeRequired'))
    }
    if (hbl && job.signHBL && !job.mblOnly && !job.masterFlag && Number(this.config.get('isAllowSEHBLNoRepeat')) === 1) {
      // HBL的Doc存在, 且勾选了HB/L,没勾选直单,且不是主票的情况下,且开启配置的情况下 才检查
      if (job.uuid && hbl.hblNbr2 && hbl.hblNbr2.trim()) {
        const count = await SeaExportJob.isExistHBL(this.context.office.officeId, 'SE', hbl.hblNbr2, job.uuid, job.etd)
        return await this.checkHBLNoResultHandler(count > 0)
      } else {
        return true
      }
    } else {
      return true
    }
  }
  async checkHBLNoResultHandler(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.HblNoRepeatedContinue'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  async checkSoNo(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.SoNoRepeatedContinue'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  async checkAmsContainersHandler() {
    const obj = await this.checkAmsContainers()
    if (obj.canSave === 0) {
      return false
    } else if (obj.canSave === 2 && obj.returnStr) {
      return await this.$confirm(obj.returnStr, this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  async checkAmsContainers() {
    const job = this.paramsOfTab
    const obj = {}
    obj.canSave = 1
    if (job.masterFlag || !job.uuid) {
      return obj
    }
    const containers = job.containerUsages
    if (!containers || containers.length === 0) {
      return obj
    }
    const containersClone = deepCopy(containers)

    const cargoDocs = job.seaCargoDoc
    if (!cargoDocs || cargoDocs.length === 0) {
      return obj
    }

    // 找出该业务下AMS所有的EDIContainer
    const ediContainers = []
    for (const seaCargoDoc of cargoDocs) {
      if (CargoDocConsts.AMS === seaCargoDoc.docType) {
        await new SeaCargoDoc(seaCargoDoc).getEdiContainer()
        if (seaCargoDoc.ediContainer && seaCargoDoc.ediContainer.length > 0) {
          ediContainers.push(...seaCargoDoc.ediContainer)
        }
      }
    }
    if (ediContainers.length === 0) {
      return obj
    }
    const ediContainersClone = deepCopy(ediContainers)

    // 存箱号,不会重复
    const containerNos = []

    // 根据箱号汇总 AMS上的EDIContainer
    const ediContainerObj = {}
    for (const ediContainer of ediContainersClone) {
      const ediContainerStr = ediContainer.eqSize + ediContainer.eqType + ediContainer.containerNo + ediContainer.sealNo
      if (!ediContainerObj.ediContainerStr) {
        ediContainerObj[ediContainerStr] = ediContainer
        containerNos.push(ediContainerStr)
      } else {
        const oldEdiContainer = ediContainerObj[ediContainerStr]
        if (oldEdiContainer) {
          oldEdiContainer.quantity += ediContainer.quantity
          oldEdiContainer.weight += ediContainer.weight
          oldEdiContainer.cubage += ediContainer.cubage
          ediContainerObj[ediContainerStr] = oldEdiContainer
        }
      }
    }

    // 根据箱号汇总 job上的装箱信息
    const containerUsageObj = {}
    for (const containerUsage of containersClone) {
      const containerUsageStr = containerUsage.eqSize + containerUsage.eqType + containerUsage.containerNo + containerUsage.sealNo
      if (!containerUsageObj[containerUsageStr]) {
        containerUsageObj[containerUsageStr] = containerUsage
      } else {
        const oldContainerUsage = containerUsageObj[containerUsageStr]
        if (oldContainerUsage) {
          oldContainerUsage.quantity += containerUsage.quantity
          oldContainerUsage.weight += containerUsage.weight
          oldContainerUsage.cubage += containerUsage.cubage
          containerUsageObj[containerUsageStr] = oldContainerUsage
        }
      }
    }

    const returnMessage = this.view.$t('Message.AMS_ReturnMessage')
    const returnMessageCanSave = this.view.$t('Message.AMS_ReturnMessageCanSave')
    let containerMessage = ''
    // 将ams装箱信息和job上的装箱信息作比较
    for (const containerInfo of containerNos) {
      const ediContainerNow = ediContainerObj[containerInfo]
      if (!ediContainerNow) {
        continue
      }

      const containerUsageNow = containerUsageObj[containerInfo]
      if (!containerUsageNow || !containerUsageNow.container) {
        continue
      }

      let conMessage = ''
      if (ediContainerNow.quantity > containerUsageNow.quantity) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Quantity'), [NumberUtils.roundHalfUp3(ediContainerNow.quantity, 0), '>', NumberUtils.roundHalfUp3(containerUsageNow.quantity, 0)])
      }
      if (ediContainerNow.weight > containerUsageNow.weight) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Weight'), [NumberUtils.roundHalfUp3(ediContainerNow.weight, 3), '>', NumberUtils.roundHalfUp3(containerUsageNow.weight, 3)])
      }
      if (ediContainerNow.cubage > containerUsageNow.cubage) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Cubage'), [NumberUtils.roundHalfUp3(ediContainerNow.cubage, 3), '>', NumberUtils.roundHalfUp3(containerUsageNow.cubage, 3)])
      }
      if (ediContainerNow.quantity < containerUsageNow.quantity) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Quantity'), [NumberUtils.roundHalfUp3(ediContainerNow.quantity, 0), '<', NumberUtils.roundHalfUp3(containerUsageNow.quantity, 0)])
      }
      if (ediContainerNow.weight < containerUsageNow.weight) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Weight'), [NumberUtils.roundHalfUp3(ediContainerNow.weight, 3), '<', NumberUtils.roundHalfUp3(containerUsageNow.weight, 3)])
      }
      if (ediContainerNow.cubage < containerUsageNow.cubage) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Cubage'), [NumberUtils.roundHalfUp3(ediContainerNow.cubage, 3), '<', NumberUtils.roundHalfUp3(containerUsageNow.cubage, 3)])
      }
      if (conMessage) {
        containerMessage += (this.getFormatText(this.view.$t('Message.AMS_ContainerNo'), [containerUsageNow.container.containerNo]) + conMessage)
      }
    }
    // 不能保存
    const isCanSave = containerMessage.indexOf('>') === -1
    if (!isCanSave) {
      obj.canSave = 0
      this.$message.warning(returnMessage + containerMessage)
      return obj
    }
    // 可以保存
    if (isCanSave && containerMessage.indexOf('<') !== -1) {
      obj.canSave = 2
      obj.returnStr = returnMessageCanSave + containerMessage
    }
    return obj
  }
  getFormatText(source, parameters) {
    if (parameters instanceof Array) {
      for (let i = 0; i < parameters.length; ++i) {
        source = source.replace('{' + i + '}', parameters[i])
      }
    }
    return source
  }
}
